module.exports = __webpack_public_path__ + "static/the-water-collector-f1a3cc175a3d2190d1d86f1df4ef0811.jpg";